// src/i18n/locales/st.js

export default {
  countries: {
    'AF': 'Afganistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antigua le Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia le Herzegovina',
    'BW': 'Botswana',
    'BR': 'Brazil',
    'BN': 'Brunei',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'CV': 'Cabo Verde',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Democratic Republic of the Congo',
    'CR': 'Costa Rica',
    'CI': 'Côte d\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czechia',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egepeta (Egypt)',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'Fora (France)',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Jeremane (Germany)',
    'GH': 'Ghana',
    'GR': 'Greece',
    'GD': 'Grenada',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HN': 'Honduras',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IL': 'Iseraele (Israel)',
    'IT': 'Itali (Italy)',
    'JM': 'Jamaica',
    'JP': 'Japane (Japan)',
    'JO': 'Jordane',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'Koreya Leboya',
    'KR': 'Koreya Borwa',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Laos',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'MX': 'Mexico',
    'FM': 'Micronesia',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'MK': 'North Macedonia',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PL': 'Poland',
    'PT': 'Portugal',
    'QA': 'Qatar',
    'RO': 'Romania',
    'RU': 'Russia',
    'RW': 'Rwanda',
    'KN': 'Saint Kitts le Nevis',
    'LC': 'Saint Lucia',
    'VC': 'Saint Vincent le Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome le Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'Afrika Borwa',
    'SS': 'South Sudan',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syria',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad le Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VA': 'Vatican City',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
  },
  verification: {
    verifying: 'Ho netefatsa imeile ya hao...',
    success: 'Imeile e Netefaditswe ka Katleho!',
    failed: 'Netefatso e Hlolehile',
    accountVerified: 'Akhaonto ya hao e netefaditswe ka katleho. Hona jwale o ka kena akhaontong ya hao.',
    invalidLink: 'Link ya netefatso ha e sebetse kapa e fedile.',
    missingToken: 'Letshwao la netefatso le siyo.',
    generalError: 'Ho bile le phoso nakong ya netefatso. Ka kopo, leka hape hamorao.',
    proceedToLogin: 'Tswela pele ho Kena',
    backToLogin: 'Khutlela ho Kena'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Dashboto',
    system: 'Sistimi',
    settings: 'Di-setting',
    overview: 'Kakaretso',
    database: 'Datha (Database)',
    logs: 'Lilog',
    userManagement: 'Tsamaiso ya Basebedisi',
    security: 'Tshireletso',
    systemAdministration: 'Tsamaiso ya Sistimi',
    loading: 'Ea kenya...',
    close: 'Kwala dashboto',
    edit: 'Fetola',
    systemUptime: 'Nako ya ho sebetsa ha Sistimi',
    avgResponseTime: 'Nako e Bohareng ya Karabelo',
    errorRate: 'Sekgahla sa Diphoso',
    activeUsers: 'Basebedisi ba Sebetsang',
    monthlyActiveUsers: 'Basebedisi ba Sebetsang ba Kgwedi le Kgwedi (MAU)',
    fromLastMonth: 'ho tloha kgweding e fetileng',
    today: 'Kajeno',
    tabs: {
      overview: 'Bophelo ba Sistimi',
      hierarchy: 'Tharollo ya Tsebo',
      documents: 'Tsamaiso ya Ditokomane',
      database: 'Datha (Database)',
      logs: 'Lilog',
      security: 'Tshireletso',
      users: 'Basebedisi'
    },
    contentManagement: "TSAMAISO YA MOKOTLA",
    knowledgeHierarchy: "Tharollo ya Tsebo",
    documentManagement: "Tsamaiso ya Ditokomane",
    noLogsFound: "Ha ho na lilog tse fumanweng bakeng sa kajeno",
    invalidLogsResponse: "Sebopeho sa karabelo ya kakaretso ya log ha se utlwahale",
    logsSummaryError: "Ho hlolehile ho kenya kakaretso ya lilog",
    buttons: {
      save: "Boloka",
      cancel: "Hlakola",
      switch: "Fetola Leha ho le Jwalo",
      discard: "Lahla"
    },
    confirm: {
      defaultTitle: "Netefatsa",
      defaultMessage: "Na o na le bonnete?"
    },
    systemHealthStatus: 'Boemo ba Bophelo ba Sistimi',
    runDiagnostics: 'Matha Tlhahlobo',
    resourceUsage: 'Tshebediso ya Dihlolwa',
    services: {
      apiServices: 'Ditshebeletso tsa API',
      database: 'Datha (Database)',
      cache: 'Polokelo (Cache)',
      storage: 'Polokelo',
      messageQueue: 'Lenane la Melaetsa',
      externalApi: 'API ya Kantle'
    },
    resources: {
      cpu: 'Tshebediso ya CPU',
      memory: 'Tshebediso ya Memori',
      storage: 'Tshebediso ya Polokelo',
      network: 'Bandwidth ya Marangrang'
    },
    databaseManagement: 'Tsamaiso ya Datha (Database)',
    reindexDatabase: 'Etsa Indekse Botjha (Reindex)',
    lastReindex: 'Tlhahlobo ya Indekse ya ho qetela',
    databaseSize: 'Boholo ba Datha (Database)',
    totalTables: 'Ditafole kaofela',
    logManagement: 'Tsamaiso ya Lilog',
    rolloverLogs: 'Fetisa Lilog (Rollover)',
    searchLogs: 'Batla Lilog',
    logTime: 'Nako',
    logLevel: 'Boemo',
    logService: 'Tshebeletso',
    logMessage: 'Molaetsa',
    showingEntries: 'Ho bontshwa dikeno tse {start}-{end} ho tse {total}',
    logLevels: {
      error: 'PHOSO',
      warn: 'TEMOSO',
      info: 'TLHAHISO-LESEDING',
      debug: 'TOKISO'
    },
    logMessages: {
      connectionTimeout: 'Nako e fedile ya kgokahano ho mofani wa kantle',
      lowDiskSpace: 'Sebaka sa polokelo se ka tlase ho 10%',
      userRoleUpdated: 'Karolo ya mosebedisi e ntlafalitswe bakeng sa admin@huduma.ai'
    },
    userName: 'Lebitso',
    userEmail: 'Imeile',
    userRole: 'Karolo',
    userStatus: 'Boemo',
    userActions: 'Diketo',
    roleAdministrator: 'Motsamaisi',
    roleUser: 'Mosebedisi',
    statusActive: 'E sebetsang',
    dbActions: {
      reindex: 'Etsa Indekse Botjha',
      backup: 'Bokella (Backup)',
      optimize: 'Ntlafatsa',
      reindexDesc: 'Tsosolosa di-index tsa database',
      backupDesc: 'Etsa backup ya database',
      optimizeDesc: 'Ntlafatsa tshebetso ya dipotso (queries)'
    },
    operations: {
      reindexTitle: 'Diphetho tsa ho Etsa Indekse Botjha',
      backupTitle: 'Diphetho tsa Backup ya Database',
      optimizeTitle: 'Diphetho tsa ho Ntlafatsa Database',
      reindexResults: 'Diphetho tsa Indekse',
      optimizeResults: 'Diphetho tsa ho Ntlafatsa',
      collection: 'Pokello',
      status: 'Boemo',
      indexSuggestions: 'Ditlhahiso tsa Indekse',
      backupDetails: 'Dintlha tsa Backup',
      backupFile: 'Faele ya Backup',
      backupLocation: 'Sebaka',
      backupSize: 'Boholo',
      errorDetails: 'Dintlha tsa Phoso',
      close: 'Kwala',
      resultsTitle: 'Diphetho tsa Tshebetso',
      reindexDatabase: {
        success: 'Ho etsa indekse botjha ya database ho phethetswe ka katleho',
        error: 'Phoso nakong ya ho etsa indekse botjha ya database',
        loading: 'E etsa indekse botjha ya database...'
      },
      backupDatabase: {
        success: 'Backup ya database e phethetswe ka katleho',
        error: 'Phoso nakong ya backup ya database',
        loading: 'E etsa backup ya database...'
      },
      optimizeDatabase: {
        success: 'Ho ntlafatsa database ho phethetswe ka katleho',
        error: 'Phoso nakong ya ho ntlafatsa database',
        loading: 'E ntlafatsa database...'
      },
      rolloverLogs: {
        success: 'Phetoho ya log e phethetswe ka katleho',
        loading: 'E fetisa lilog...'
      },
      searchLogs: {
        success: 'Patlo ya log e phethetswe',
        loading: 'E batla lilog...'
      },
      runDiagnostics: {
        success: 'Tlhahlobo e phethetswe ka katleho',
        loading: 'E matha tlhahlobo...'
      },
      runSecurityScan: {
        success: 'Ho lekolwa ha tshireletso ho phethetswe ka katleho',
        loading: 'E matha tekolo ya tshireletso...'
      },
      cancel: 'Hlakola',
      save: 'Boloka Diphetoho'
    },
    userManagementSection: {
      totalUsers: 'Basebedisi kaofela',
      newUsers: 'Basebedisi ba Batjha (Kgwedi)',
      searchUsers: 'Batla basebedisi...',
      clearSearch: 'Hlakola patlo',
      search: 'Batla',
      usersFound: 'basebedisi ba fumanwe',
      showAllUsers: 'Bontsha Basebedisi Bohle',
      searching: 'Ea batla...',
      searchingUsers: 'E batla basebedisi...',
      noUsersFound: 'Ha ho na basebedisi ba fumanweng ho ipapisitsoe le diphetho tsa hao.',
      noUsers: 'Ha ho na basebedisi ba fumanehang.',
      showing: 'E bontsha',
      of: 'ho',
      previous: 'E fetileng',
      next: 'E latelang',
      searchFields: {
        all: 'Dikarolo Tsohle',
        name: 'Lebitso',
        email: 'Imeile',
        role: 'Karolo'
      },
      userSearch: {
        resultsFound: 'Ho fumanwe basebedisi ba {total} ba tshoanang le "{term}"',
        error: 'Phoso ha ho batlwa basebedisi'
      }
    },
    logsSection: {
      errorLogs: 'Lilog tsa Diphoso',
      warningLogs: 'Lilog tsa Temoso',
      noErrorLogs: 'Ha ho na lilog tsa diphoso tse rekotilweng kajeno.',
      noWarningLogs: 'Ha ho na lilog tsa temoso tse rekotilweng kajeno.',
      infoLogsNote: 'Lilog tsa tlhahiso-leseding ha di bontshwe tlhahisoleseding e khutsufatsang. Sebedisa patlo ho bona mefuta yohle ya log.',
      searchResults: 'Diphetho tsa Morao-rao tsa Patlo',
      entriesFound: 'dikeno di fumanwe',
      viewAllResults: 'Bona Diphetho Tsohle',
      logType: 'Mofuta',
      logCount: 'Palo',
      logTypes: {
        connectionTimeout: 'Nako ya kgokahano e fedile',
        databaseFailed: 'Tlhahlobo ya database e hlolehile',
        authFailed: 'Netefatso ya botho e hlolehile',
        lowDiskSpace: 'Sebaka se tlase sa disk',
        slowQuery: 'Tshebetso e fokolang ya dipotso',
        rateLimit: 'Moedi wa lebelo o ntse o atamela'
      },
      logSearch: {
        noResultsFound: 'Ha ho na lilog tse tshoanang le patlo ya hao',
        resultsFound: 'Ho fumanwe dikeno tsa log tse {count}'
      }
    },
    security: {
      title: 'Tlhokomelo ya Tshireletso',
      securityScan: 'Tekolo ya Tshireletso',
      runningSecurityScan: 'E Matha Tekolo...',
      lastSecurityScan: 'Tekolo ya ho Qetela ya Tshireletso',
      vulnerabilitiesFound: 'Mabala a Fokolang a Fumanwe',
      daysAgo: 'matsatsi a fetileng',
      critical: 'tse kotsi haholo',
      medium: 'tse bohareng',
      low: 'tse tlase',
      failedLoginAttempts: 'Diteko tse Hlolehileng tsa ho Kena (24h)',
      suspiciousActivities: 'Mesebetsi e Belaetsang (24h)',
      securityRecommendations: 'Dikhothaletso tsa Tshireletso',
      criticalVulnerabilities: 'Mabala a Kotsi haholo',
      mediumVulnerabilities: 'Mabala a Bohareng',
      lowVulnerabilities: 'Mabala a Tlase',
      authenticationIssues: 'Mathata a ho Netefatsa Botho',
      suspiciousActivityLogs: 'Lilog tsa Mesebetsi e Belaetsang',
      securityProbeAttempts: 'Diteko tsa Tekolo ya Tshireletso di Fumanwe',
      sensitiveFileAccess: 'diteko tsa ho fihlella difaele kapa metjha e hlokolosi di fumanwe',
      envFileAccess: 'Diteko tsa ho Fihlella faele ya Environment (.env)',
      envFileAccessDesc: 'diteko tsa ho fihlella difaele tsa .env di fumanwe',
      gitRepoAccess: 'Diteko tsa ho Fihlella faele tsa Git Repository',
      gitRepoAccessDesc: 'diteko tsa ho fihlella difaele tsa Git repository di fumanwe',
      recommendedAction: 'Keto e kgothaletswang',
      rateLimitRecommendation: 'Nka mehato ya ho sebedisa meedi ya ho kena, IP blocking, le ho thetsa tshireletso ya seva e nepahetseng.',
      envFileRecommendation: 'Etsa bonnete ba hore difaele tsa environment ha di kgone ho fihlellwa webong mme di bolokehile ho seva.',
      gitRepoRecommendation: 'Etsa bonnete ba hore direkthori tsa .git di sireleditswe mme ha di kgone ho fihlellwa webong.',
      noVulnerabilitiesFound: 'Ha ho Mabala a Fokolang a Fumanweng',
      systemSecure: 'Sistimi ya hao e bonahala e sireletsehile. Tswela pele ho beha leihlo nako le nako.',
      loadingScan: 'E kenya diphetho tsa tekolo...',
      occurrences: 'Diketsahalo',
      firstSeen: 'E qadile ho bonwa neng',
      lastSeen: 'E qetetse ho bonwa neng',
      timestamp: 'Setempe sa Nako (Timestamp)',
      message: 'Molaetsa',
      service: 'Tshebeletso',
      type: 'Mofuta',
      severity: 'Kotsi',
      url: 'URL',
      matchedTerm: 'Polelo e Tshoanang',
      lineNumber: 'Nomoro ya Mola',
      lineNumbers: 'Dinomoro tsa Mela',
      showLess: 'Bontsha tse Nnyane',
      showMore: 'Bontsha Mathata kaofela',
      lastScanJustNow: "Hona jwale"
    },
    userEdit: {
      title: 'Fetola Mosebedisi',
      loading: 'E kenya datha ya mosebedisi...',
      userInfo: 'Tlhahisoleseding ya Mosebedisi',
      userId: 'ID ya Mosebedisi',
      loginName: 'Lebitso la ho Kena',
      fullName: 'Lebitso le Feletseng',
      dob: 'Letsatsi la tswalo',
      email: 'Imeile',
      emailVerified: 'Imeile e Netefaditswe',
      verified: 'E netefaditswe',
      notVerified: 'Ha e ya netefatswa',
      createdAt: 'E thehilwe',
      lastLogin: 'Ho Kena ha ho Qetela',
      never: 'Le ka mohla',
      accountSettings: 'Di-setting tsa Akhaonto',
      accountStatus: 'Boemo ba Akhaonto',
      accountEnabled: 'Akhaonto e Dumelletswe',
      cannotDisableSelf: 'O ke ke wa emisa akhaonto ya hao',
      accountRole: 'Karolo ya Akhaonto',
      adminRole: 'Karolo ya Admin',
      cannotChangeOwnRole: 'O ke ke wa fetola karolo ya hao',
      adminActions: 'Diketo tsa Admin',
      verifyEmail: 'Netefatsa Imeile',
      resetPassword: 'Romela Seta Phasewete Botjha',
      forceLogout: 'Qobella ho Tswa',
      failedToLoad: 'Ho hlolehile ho kenya datha ya mosebedisi',
      errorLoading: 'Phoso ha ho kenngwa datha ya mosebedisi',
      saveSuccess: 'Di-setting tsa mosebedisi di ntlafaditswe ka katleho',
      errorSaving: 'Phoso ha ho bolokwa di-setting tsa mosebedisi',
      verifyEmailSuccess: 'Imeile ya netefatso e rometswe ka katleho',
      emailVerificationFailed: 'Ho hlolehile ho romela imeile ya netefatso',
      errorVerifyingEmail: 'Phoso ha ho romelwa imeile ya netefatso',
      passwordResetSent: 'Imeile ya ho seta phasewete e rometswe',
      passwordResetFailed: 'Ho hlolehile ho romela ho seta phasewete botjha',
      errorSendingReset: 'Phoso ha ho romelwa ho seta phasewete botjha',
      logoutForced: 'Mosebedisi o ntsheditswe ka ntle',
      logoutFailed: 'Ho hlolehile ho qobella ho tswa',
      errorForcingLogout: 'Phoso ha ho qobellwa ho tswa',
      userUpdated: "Mosebedisi o ntlafaditswe ka katleho"
    },
    hierarchy: {
      title: "Tsamaiso ya Tharollo ya Tsebo (ela hloko: e dula e le ka Senyesemane - eketsa diphetolelo)",
      addCategory: "Eketsa Sehlopha se Setjha",
      loading: "E kenya Tharollo...",
      addService: "Eketsa Tshebeletso",
      editCategory: "Fetola Sehlopha",
      deleteCategory: "Hlakola Sehlopha",
      editService: "Fetola Tshebeletso",
      deleteService: "Hlakola Tshebeletso",
      empty: 'Ha ho dihlopha tse fumanweng. Tobetsa "Eketsa Sehlopha se Setjha" ho qala.',
      formTitleCreateCategory: "Theha Sehlopha se Setjha",
      formTitleAddService: "Eketsa Tshebeletso ho \"{categoryName}\"",
      formTitleEditCategory: "Fetola Sehlopha: \"{itemName}\"",
      formTitleEditService: "Fetola Tshebeletso: \"{itemName}\"",
      nameEnLabel: "Lebitso (Senyesemane)",
      translationsTitle: "Diphetolelo bakeng sa Pontsho",
      loadingTranslations: "E kenya diphetolelo...",
      selectLang: "Kgetha Puo",
      translationPlaceholder: "Kenya phetolelo",
      deleteTranslation: "Hlakola Phetolelo",
      addTranslation: "+ Eketsa Phetolelo",
      saveSuccess: "Ntho ya tharollo e bolokilwe ka katleho.",
      saveError: "Ho hlolehile ho boloka ntho ya tharollo.",
      loadError: "Ho hlolehile ho kenya tharollo ya tsebo.",
      loadTranslationsError: "Ho hlolehile ho kenya diphetolelo.",
      confirmCancelTitle: "Diphetoho tse sa Bolokoang",
      confirmCancelEdit: "O na le diphetoho tse sa bolokoang. Na o na le bonnete ba hore o batla ho hlakola?",
      confirmDeleteTitleCategory: "Hlakola Sehlopha?",
      confirmDeleteTitleService: "Hlakola Tshebeletso?",
      confirmDeleteCategory: "Na o na le bonnete ba hore o batla ho hlakola Sehlopha sa \"{itemName}\"? Keto ena ha e kgutlele morao.",
      confirmDeleteService: "Na o na le bonnete ba hore o batla ho hlakola Tshebeletso ya \"{itemName}\"? Keto ena ha e kgutlele morao.",
      deleteSuccessCategory: "Sehlopha se hlakotswe ka katleho.",
      deleteSuccessService: "Tshebeletso e hlakotswe ka katleho.",
      deleteErrorCategory: "Ho hlolehile ho hlakola Sehlopha.",
      deleteErrorService: "Ho hlolehile ho hlakola Tshebeletso.",
      duplicateLangError: "Dipuo tse peli tse tshwanang di fumanwe diphetolelong. Ka kopo, di tlose."
    },
    documents: {
      title: "Tsamaiso ya Ditokomane",
      addLink: "Eketsa ho tswa ho Link",
      uploadFiles: "Kenya Difaele",
      searchPlaceholder: "Batla ka lebitso la faele...",
      allStatuses: "Maemo Ohle",
      statusPending: "Etsweletse",
      statusIngested: "E Kentswe",
      statusRetracted: "E Hulelwe Morao",
      statusIngesting: "E ntse e Kentswe",
      statusError: "Phoso ya ho Kenya",
      statusWarning: "E Kentswe le Ditemoso",
      ingestSelected: "Kenya ho Kgethilweng",
      colFileName: "Lebitso la Faele",
      colStatus: "Boemo",
      colLabels: "Mabitso",
      colUploadDate: "Letsatsi la ho Kenya",
      colSize: "Boholo",
      loading: "E kenya ditokomane...",
      empty: "Ha ho ditokomane tse fumanweng.",
      loadError: "Ho hlolehile ho kenya ditokomane.",
      confirmIngestTitle: "Netefatsa ho Kenya ha Sehlopha",
      ingest: "Kenya",
      confirmIngestSelected: "Na o na le bonnete ba hore o batla ho kenya difaele tse {count} tse kgethilweng?",
      ingestQueuedSuccess: "Difaele tse {count} di hlophisitswe molemong wa ho kenngwa.",
      ingestQueuedError: "Ho bile le phoso nakong ya tshebetso ya ho kenya sehlopha.",
      uploadSuccessMultiple: "Difaele tse {count} di kentswe ka katleho.",
      linkSubmitSuccess: "E fetile le ho boloka \"{fileName}\" ka katleho.",
      actionSuccess: "Keto ya \"{action}\" faeleng ya {fileId} e bile le katleho.",
      metadataUpdateSuccess: "Metadata ya faele ya {fileId} e ntlafaditswe."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Theha Phasewete e Ntjha',
    tokenLabel: 'Letshwao la ho Seta Botjha',
    tokenPlaceholder: 'Kenya letshwao la ho seta botjha',
    validateButton: 'Netefatsa Letshwao',
    newPasswordLabel: 'Phasewete e Ntjha',
    newPasswordPlaceholder: 'Theha phasewete e ntjha',
    confirmNewPasswordLabel: 'Netefatsa Phasewete e Ntjha',
    confirmNewPasswordPlaceholder: 'Netefatsa phasewete e ntjha ya hao',
    resetButton: 'Seta Phasewete Botjha',
    processing: 'E ntse e sebetsa...',
    rememberedPassword: 'O hopotse phasewete ya hao?',
    backToLogin: 'Khutlela ho Kena',
    supportMessage: 'Na o hloka thuso? Ikopanye le sehlopha sa rona sa tshehetso',
    passwordRequirements: 'Phasewete e tlameha ho ba le ditlhaku tse 8 bonyane mme e be le nomoro e 1, tlhaku e kgolo e 1, le tlhaku e kgethehileng e 1',
    passwordsDoNotMatch: 'Diphasewete ha di tshwane',
    resetSuccess: 'Phasewete ya hao e setilwe botjha ka katleho',
    resetFailed: 'E sitwa ho seta phasewete botjha. Ka kopo leka hape.',
    noTokenProvided: 'Ka kopo fana ka letshwao la ho seta botjha',
    expiredToken: 'Letshwao lena la ho seta botjha le fedile. Ka kopo, kopa e ntjha.',
    invalidToken: 'Letshwao la ho seta botjha ha le sebetse kapa ha le tsejwe',
    validatingToken: 'E netefatsa letshwao...',
    redirecting: 'E isa ho leqephe la ho kena...',
    passwordStrength: 'Matla a Phasewete',
    strengthLabels: {
      veryWeak: 'E Fokolang Haholo',
      weak: 'E Fokolang',
      fair: 'E Mahareng',
      good: 'E Ntle',
      strong: 'E Matla'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Sebedisa bonyane ditlhaku tse 8',
      addUppercase: 'Eketsa ditlhaku tse kgolo',
      addLowercase: 'Eketsa ditlhaku tse nyane',
      addNumbers: 'Eketsa dinomoro',
      addSpecialChars: 'Eketsa ditlhaku tse kgethehileng'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Seta Phasewete ya Hao Botjha',
    emailLabel: 'Aterese ya Imeile',
    emailPlaceholder: 'Kenya imeile ya hao',
    resetButton: 'Romela Link ya ho Seta Botjha',
    processing: 'Ea romela...',
    rememberPassword: 'O hopotse phasewete ya hao?',
    backToLogin: 'Khutlela ho Kena',
    supportMessage: 'Na o hloka thuso? Ikopanye le sehlopha sa rona sa tshehetso',
    invalidEmail: 'Ka kopo kenya aterese ya imeile e nepahetseng',
    resetRequestSuccess: 'Link ya ho seta phasewete botjha e rometswe ho imeile ya hao',
    resetRequestFailed: 'E sitwa ho romela link ya ho seta phasewete botjha. Ka kopo leka hape.',
    checkEmail: 'Ka kopo, hlahloba imeile ya hao bakeng sa ditaelo tse ding.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Theha Akhaonto e Ntjha",
    username: "Lebitso la mosebedisi",
    usernamePlaceholder: "Kenya lebitso la mosebedisi",
    email: "Imeile",
    emailPlaceholder: "Kenya imeile ya hao",
    password: "Phasewete",
    passwordPlaceholder: "Theha phasewete",
    confirmPassword: "Netefatsa Phasewete",
    confirmPasswordPlaceholder: "Netefatsa phasewete ya hao",
    acceptTerms: "Ke amohela",
    termsOfService: "Melao le Ditshebeletso",
    registerButton: "Theha Akhaonto",
    processing: "E ntse e sebetsa...",
    alreadyHaveAccount: "O se o na le akhaonto?",
    loginNow: "Kena mona",
    privacyNotice: "Ka ho ingodisa, o dumellana le Melao le Ditshebeletso ya rona le Leano la Lekunutu",
    usernameMinLength: "Lebitso la mosebedisi le tlameha ho ba le ditlhaku tse 3 bonyane",
    invalidEmail: "Ka kopo kenya aterese ya imeile e nepahetseng",
    passwordRequirements: "Phasewete e tlameha ho ba le ditlhaku tse 8 bonyane le nomoro e 1 le tlhaku e kgolo e 1",
    passwordsDoNotMatch: "Diphasewete ha di tshwane",
    mustAcceptTerms: "O tlameha ho amohela Melao le Ditshebeletso",
    registrationFailed: "Ho ngodisa ho hlolehile. Ka kopo leka hape.",
    usernameExists: "Lebitso la mosebedisi le se le ntse le le teng",
    emailExists: "Imeile e se e ntse e le teng",
    registrationSuccess: "Kgodiso e atlehile!",
    verificationEmailSent: "Imeile ya netefatso e rometswe ho {email}",
    checkEmailInstructions: "Ka kopo hlahloba imeile ya hao mme o latele ditaelo tsa ho netefatsa akhaonto ya hao pele o kena.",
    backToLogin: "Khutlela ho Kena",
    noEmailReceived: "Ha o a fumana imeile?",
    resendVerification: "Romela imeile ya netefatso hape",
    verificationResent: "Imeile ya netefatso e rometswe hape",
    verificationResendFailed: "Ho hlolehile ho romela imeile ya netefatso hape. Ka kopo leka hape.",
    usernameInvalidChars: 'Lebitso la mosebedisi le ka ba le ditlhaku, dinomoro, di-underscore, di-dots le di-hyphen feela',
    networkError: 'Phoso ya marangrang. Ka kopo hlahloba kgokahano ya hao mme o leke hape.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Lebitso la mosebedisi',
    password: 'Phasewete',
    loginButton: 'Kena',
    or: 'kapa',
    savedAccounts: 'Diakhaonto tse Bolokilweng',
    loginSuccess: 'O kene ka katleho',
    loginError: 'Ho kena ho hlolehile. Ka kopo hlahloba dintlha tsa hao.',
    googleLogin: 'Tswela pele ka Google',
    facebookLogin: 'Tswela pele ka Facebook',
    rememberMe: 'Nkhopole',
    forgotPassword: 'O lebetse phasewete?',
    noAccount: 'Ha o na akhaonto?',
    createAccount: 'Theha akhaonto',
    registerNow: "Ikunye ho rona jwale",
    termsAndPolicy: 'Ka ho kena, o dumellana le Melao le Ditshebeletso ya rona le Leano la Lekunutu',
    loggingIn: "Ea kena...",
    fieldsRequired: "Lebitso la mosebedisi le phasewete di a hlokahala",
    invalidCredentials: "Lebitso kapa phasewete ha e nepa",
    tooManyAttempts: "Diteko tse ngata tsa ho kena. Ka kopo leka hape hamorao.",
    loginFailed: "Ho kena ho hlolehile. Ka kopo leka hape.",
    oauthNotImplemented: "Ho kena ka marang-rang a sechaba ha ho eso kenngwe tshebetsong",
    savedLoginNotImplemented: "Ho kena ha akhaonto e bolokilweng ha ho eso kenngwe tshebetsong"
  },
  charts: {
    tooltip: {
      title: 'Letsatsi',
      totalQueries: 'Dipotso kaofela',
      uniqueUsers: 'Basebedisi ba fapaneng'
    },
    day: 'Letsatsi',
    noData: 'Ha ho Datha',
    notAvailable: 'Ha e Fumanehe',
    topQueries: 'Dipotso tse Tlwaelehileng',
    categoryDistribution: 'Tshebediso ya Sebaka sa Tsebo',
    usageTrend: 'Mokgwa wa Tshebediso'
  },
  analytics: {
    title: 'Tshekatsheko ya Datha le Maikutlo',
    loading: 'E kenya datha ya tshekatsheko...',
    period: 'Nako',
    charts: {
      satisfactionHeatmap: "Kgotsofalo ka Sebaka sa Tsebo",
      satisfactionSubtitle: "Dipesente tsa matshwao ha nako e ntse e tsamaya"
    },
    timePeriods: {
      week4: "Dibeke tse 4 tse fetileng",
      week3: "Dibeke tse 3 tse fetileng",
      week2: "Dibeke tse 2 tse fetileng",
      week1: "Beke e fetileng",
      current: "Ya Hona Jwale"
    },
    errors: {
      loading: "Ho hlolehile ho kenya datha ya kgotsofalo. Ka kopo leka hape.",
    },
    status: {
      loading: 'Ea kenya...',
      noData: 'Ha ho datha e fumanehang bakeng sa nako ena',
      error: 'Ho hlolehile ho kenya datha ya tshekatsheko',
      online: "Sistimi e Marang-rang",
      offline: "Sistimi ha e Marang-rang",
      responseTime: "Nako e Bohareng ya Karabelo",
      queueLength: "Mohlape",
      uptime: "Nako ya ho Sebetsa"
    },
    periods: {
      daily: 'Kamehla',
      weekly: 'Beke le beke',
      monthly: 'Kgwedi le Kgwedi',
      allTime: 'Nako tsohle'
    },
    metrics: {
      totalQueries: 'Dipotso kaofela',
      uniqueUsers: 'Basebedisi ba ikgethang',
      avgResponseTime: 'Nako e Bohareng ya Karabelo',
      satisfaction: 'Kgotsofalo ya Mosebedisi'
    },
    table: {
      rank: 'Boemo',
      query: 'Potso',
      count: 'Palo',
      avgTime: 'Nako e Bohareng'
    },
    chartLabels: {
      categories: 'Dibaka',
      serviceCategories: 'Dibaka tsa Tsebo',
      byUsage: 'ka Tshebediso',
      category: 'Sebaka'
    },
    tooltips: {
      selectPeriod: 'Kgetha nako',
      selectDate: 'Kgetha letsatsi',
      exportData: 'Ntshetsa datha kantle'
    },
    gauge: {
      historical: 'Mekgwa ya Histori',
      vsPrevious: 'keng nako e fetileng',
      target: 'Tebello'
    },
    ratings: {
      poor: "E Mpe",
      average: "E Bohareng",
      good: "E Ntle",
      excellent: "E Ntle Haholo"
    },
    slower: 'e theohileng',
    faster: 'e potlakileng',
    percentage: 'Peresente',
    note: 'Ka tlase mona ho na le dipalopalo tsa tshebediso le dikakaretso tsa diphetho tsa mosebedisi.',
    usageStats: 'Dipalopalo tsa Tshebediso',
    peakUsers: 'Bongata ba Basebedisi ba Etsahalang ka Nako e Le Nngwe',
    activeChats: 'Moqoqo e Sebetsang',
    usageTrend: 'Mokgwa wa Tshebediso',
    topQueries: 'Dipotso tse Tlwaelehileng',
    feedbackSamples: 'Mehlala ya Maikutlo a Basebedisi',
    close: 'Kwala',
    chartComingSoon: 'Pono ya chate e tla haufinyane...',
    retry: 'Leka hape',
    dailyQueries: 'Dipotso tsa Letsatsi',
    export: 'Ntshetsa Datha Kantle',
    dateRange: 'Mefuta ya Matsatsi',
    startDate: 'Letsatsi la ho Qala',
    endDate: 'Letsatsi la ho Qetela',
    rank: 'Boemo',
    query: 'Potso',
    count: 'Palo',
    avgTime: 'Nako e Bohareng',
    serviceUsage: 'Tshebediso ya Sebaka sa Tsebo',
    usageTrends: 'Mekgwa ya Tshebediso',
    week: 'Beke e fetileng',
    month: 'Kgwedi e fetileng',
    quarter: 'Kotara e fetileng',
    year: 'Selemo se fetileng',
    uniqueUsers: 'Basebedisi ba ikgethang',
    satisfactionRate: 'Sekgahla sa Kgotsofalo',
    satisfactionAnalysis: 'Tshekatsheko ya Kgotsofalo ya Mosebedisi'
  },
  brandName: 'Genie AI: Mothusi wa hao wa Mmuso wa Digital',
  nav: {
    systemStatus: 'Boemo ba Sistimi',
    menu: 'Lenane',
    analytics: 'Tshekatsheko',
    userProfile: 'Profaele ya Mosebedisi',
    settings: 'Di-setting',
    logout: 'Tswa',
    profile: 'Profaele ya ka',
    toggleSidebar: 'Bula/Kwala lenane le lehlakoreng',
    changeLanguage: 'Fetola puo',
    administration: "Tsamaiso",
    languages: {
      english: 'Senyesemane',
      french: 'Sefora',
      swahili: 'Seswahili'
    }
  },
  systemStatus: {
    title: 'Boemo ba Tshebeletso',
    services: 'Ditshebeletso',
    operational: 'Ea sebetsa',
    degraded: 'E Fokotsehile',
    outage: 'Ho Kgaohwa',
    allOperational: 'Disistimi Tsohle',
    someIssues: 'Mathata a mang',
    majorIssues: 'Mathata a Maholo',
    checking: 'Ea hlahloba...',
    nextDeadline: 'Nako ya ho Qetela e Latelang',
    days: 'matsatsi',
    viewDetails: 'Bona Dintlha'
  },
  services: {
    eCitizen: 'eCitizen Portal',
    taxFiling: 'Sistimi ya ho Kenya Lekgetho',
    idApplication: 'Kopo ya ID',
    businessReg: 'Ngwadisong ya Kgwebo',
    drivingLicense: 'Laesense ya ho Kganna'
  },
  deadlines: {
    taxFiling: 'Nako ya ho Qetela ya ho Kenya Lekgetho',
    businessRenewal: 'Ntjhafatso ya Laesense ya Kgwebo',
    idRenewal: 'Ntjhafatso ya Karata ya ID',
    vehicleRegistration: 'Nako ya ho Qetela ya Ngwadisong ya Koloi'
  },
  sidebar: {
    governmentServices: 'Dibaka tsa Tsebo',
    chatHistory: 'Nalane ya Moqoqo',
    searchPlaceholder: 'Batla dibaka tsa tsebo...',
    createFolder: 'Theha Sephuthedi',
    editFolder: 'Fetola Sephuthedi',
    folderName: 'Lebitso la Sephuthedi',
    folderNamePlaceholder: 'Kenya lebitso la sephuthedi',
    moveChat: 'Tlosa Moqoqo',
    moveChatTo: 'Tsudutsetsa Moqoqo Ho',
    selectFolder: 'Kgetha Sephuthedi',
    deleteChat: 'Hlakola Moqoqo',
    deleteChatConfirm: 'Na o na le bonnete ba hore o batla ho hlakola moqoqo oo?',
    deleteChatWarning: 'Keto ena ha e kgutlele morao.',
    renameChat: "Rea Moqoqo Lebitso",
    chatTitle: "Sehlooho sa Moqoqo",
    chatTitlePlaceholder: "Kenya sehlooho bakeng sa moqoqo ona",
    deleteFolder: "Hlakola Sephuthedi",
    deleteFolderConfirm: "Na o na le bonnete ba hore o batla ho hlakola sephuthedi sa '{name}'?",
    chatsMoveWarning: "Meqoqo yohle ka hara sephuthedi sena e tla suthisetswa sephutheding se tlwaelehileng.",
    weatherError: "Ha e kgone ho kenya datha ya boemo ba lehodimo. Ka kopo leka hape.",
    weatherTitle: 'Boprofeta ba Boemo ba Lehodimo',
    weatherLoading: 'E kenya datha ya boemo ba lehodimo...',
    weatherLocationLoading: 'E kenya sebaka...',
    weatherErrorDefault: 'E sitwa ho fumana datha ya boemo ba lehodimo.',
    weatherGeolocationUnsupported: 'Sebaka sa mmele ha se tshehetswe ke phetisi ya hao ya inthanete.',
    weatherRefresh: 'Ntlafatsa Boemo ba Lehodimo',
    weatherConditions: {
      clear: 'Hlakileng',
      partlycloudy: 'Maru a Mang',
      cloudy: 'Maru',
      overcast: 'Letshwiti',
      rain: 'Pula',
      shower: 'Pulanyana',
      thunderstorm: 'Pula ya Dioduma',
      snow: 'Lehlwa'
    },
    folders: "Diphuthedi",
    emptyFolder: "Sephuthedi sena se se nang letho. Suthisetsa meqoqo mona ho tswa lenaneng la moqoqo.",
    title: 'Lesedi & Mehlodi',
    noChats: 'Ha ho meqoqo ya morao-rao',
    relatedDocs: 'Ditokomane tse Amanang',
    noDocuments: 'Ha ho ditokomane tse amanang',
    faq: 'Dipotso tse Botswang Kgafetsa (FAQ)',
    tab: {
      all: 'Meqoqo Yotlhe',
      folders: 'Diphuthedi',
      starred: 'E Kgethilweng ka Linaledi',
      archived: 'E Bolokilweng polokelong'
    },
    savedChats: 'Meqoqo e Bolokilweng',
    chats: "Meqoqo",
    allChats: "Meqoqo Yotlhe",
    noFolder: "Ha ho Sephuthedi",
    starredChats: "Meqoqo e Kgethilweng ka Linaledi",
    archivedChats: "Meqoqo e Bolokilweng",
    noStarredChats: "Ha ho meqoqo e kgethilweng ka linaledi ha jwale. Kgetha moqoqo ka naledi ho o kenya mona.",
    noArchivedChats: "Ha ho meqoqo e bolokilweng ha jwale.",
    noSearchResults: 'Ha ho meqoqo e fumanweng bakeng sa "{term}"',
    loadingChats: "E kenya meqoqo...",
    errorLoadingConversations: "Ho hlolehile ho kenya meqoqo. Ka kopo leka hape.",
    errorLoadingUser: "Datha ya mosebedisi ha ea fella. Ka kopo, kenya leqephe bocha.",
    errorNoUser: "Datha ya mosebedisi e haella. Ka kopo, kenya leqephe bocha.",
    retry: "Leka hape",
    message: "molaetsa",
    messages: "melaetsa",
    created: "E thehilwe",
    updated: "E ntlafaditswe",
    star: "Kgetha ka Naledi",
    unstar: "Tlosa Naledi",
    archive: "Boloka polokelong",
    chatStarred: "Moqoqo o kgethilwe ka naledi",
    chatUnstarred: "Naledi e tlositswe moqoqong",
    chatArchived: "Moqoqo o bolokilwe polokelong",
    chatUnarchived: "Moqoqo o ntshitswe polokelong",
    errorUpdatingChat: "Ho hlolehile ho ntlafatsa moqoqo",
    chatRenamed: "Moqoqo o reilwe lebitso bocha ka katleho",
    errorRenamingChat: "Ho hlolehile ho rea moqoqo lebitso botjha",
    chatDeleted: "Moqoqo o hlakotswe ka katleho",
    errorDeletingChat: "Ho hlolehile ho hlakola moqoqo",
    chatMoved: "Moqoqo o suthisitswe ka katleho",
    errorMovingChat: "Ho hlolehile ho suthisa moqoqo",
    noPreview: "Ha ho ponelopele e fumanehang",
    searchConversations: 'Batla meqoqo...',
    selectFolderInstruction: "Kgetha sephuthedi ho bona meqoqo ya sona",
    folderCreated: "Sephuthedi se thehilwe ka katleho",
    errorCreatingFolder: "Ho hlolehile ho theha sephuthedi",
    errorLoadingFolders: "Ho hlolehile ho kenya diphuthedi",
    folderUpdated: "Sephuthedi se ntlafaditswe ka katleho",
    errorUpdatingFolder: "Ho hlolehile ho ntlafatsa sephuthedi",
    folderDeleted: "Sephuthedi se hlakotswe ka katleho",
    errorDeletingFolder: "Ho hlolehile ho hlakola sephuthedi",
    chatRemovedFromFolders: "Moqoqo o tlositswe sephutheding",
    errorRemovingChat: "Ho hlolehile ho tlosa moqoqo sephutheding",
    id: 'ID',
    labels: 'Mabitso',
    confidence: 'Tshepo',
    unknown: 'E sa tsejweng'
  },
  leftPanel: {
    cat1: {
      name: '1. Boitsebiso & Ngwadisong ya Baahi',
      children: ['Difiketi tsa tswalo', 'Dikarata tsa naha tsa ID', 'Dipasporoto', 'Difiketi tsa lenyalo le lefu', 'Ngwadisong ya bakgethi']
    },
    cat2: {
      name: '2. Bophelo bo Botle & Ditshebeletso tsa Setjhaba',
      children: ['Ho fihlella tlhokomelo ya bophelo ya setjhaba', 'Mananeo a ho enta', 'Inshorense ya bophelo bo botle', 'Melemo ya ho holofala', 'Thuso ya thepa le dijo']
    },
    cat3: {
      name: '3. Thuto & Ho Ithuta',
      children: ['Dikolo tsa setjhaba le diyunivesithi', 'Dikhau tsa thuto le dikadimo tsa baithuti', 'Mananeo a thuto ya batho ba baholo', 'Dihlolwa tsa ho ithuta inthaneteng']
    },
    cat4: {
      name: '4. Mesebetsi & Ditshebeletso tsa Basebetsi',
      children: ['Patlo ya mosebetsi le melemo ya ho hloka mosebetsi', 'Tshireletso ya basebetsi le ditokelo tsa basebetsi', 'Melawana ya tshireletso ya mosebetsing', 'Koetliso ya tsebo le mananeo a koetliso']
    },
    cat5: {
      name: '5. Lekgetho & Lekeno',
      children: ['Puseletso le faele ya lekgetho la lekeno', 'Ditefello tsa lekgetho la thepa', 'Ho ipapisa le lekgetho la kgwebo', 'Mekgwa ya mesebetsi le mesebetsi ya ho reka thepa kantle']
    },
    cat6: {
      name: '6. Tshireletso ya Setjhaba & Toka',
      children: ['Maponesa le ditshebeletso tsa tshohanyetso', 'Makgotla le ditshebeletso tsa thuso ya molao', 'Ho tlaleha botlokotsebe', 'Melao ya tshireletso ya bareki']
    },
    cat7: {
      name: '7. Dipalangwang & Tsela',
      children: ["Dilaesense tsa bakhanni le ngwadisong ya makoloi", 'Lipalangwa tsa setjhaba le mehaho', 'Ditlolo tsa molao wa sephethephethe le ditefiso', 'Mananeo a tshireletso ya tsela']
    },
    cat8: {
      name: '8. Matlo & Ntshetsopele ya Ditoropo',
      children: ['Thuso ya matlo a setjhaba', 'Ngwadisong ya thepa le ditlaleho tsa mobu', 'Dikadimo tsa matlo le dithuso', 'Diforomo tsa meaho le dilaesense']
    },
    cat9: {
      name: '9. Ditshebeletso tse Sebetsang & Tikoloho',
      children: ['Ditshebeletso tsa metsi le motlakase', 'Tsamaiso ya ditshila le ho sebetsa botjha', 'Melawana ya tikoloho', 'Mehato ya eneji e ntjhafatsoang']
    },
    cat10: {
      name: '10. Kgwebo & Kgwebo e Bohareng',
      children: ['Ngwadisong ya kgwebo le laesense', 'Melawana ya kgwebo le diforomo', 'Dikhau tsa kgwebo e nyane le dithuso', 'Tshetsopele ya e-commerce le theknoloji ya kgwebo']
    },
    cat11: {
      name: '11. Tshireletso ya Setjhaba & Dipenshene',
      children: ['Melemo ya ho tlohela mosebetsi', 'Tsamaiso ya letlole la penshene', 'Melemo ya baphonyohi', 'Dipenshene tsa ho holofala']
    },
    cat12: {
      name: '12. Setjhaba & Ho Nka Karolo ha Setjhaba',
      children: ['Dikgetho le ho vouta', 'Maikutlo a setjhaba le ditletlebo tsa baahi', 'Ho ithaopa le mananeo a setjhaba', 'Ho nka karolo mmusong wa lehae']
    }
  },
  settings: {
    title: 'Di-setting',
    save: 'Boloka',
    close: 'Kwala',
    saveSettings: 'Boloka Di-setting',
    savingSettings: "E boloka di-setting tsa hao...",
    settingsSaved: "Di-setting di bolokilwe ka katleho!",
    saveSuccess: 'Di-setting di bolokilwe ka katleho',
    saveError: 'Phoso ha ho bolokwa di-setting',
    display: 'Ponahalo',
    displayLanguage: 'Puo ya Ponahalo',
    languages: {
      english: 'Senyesemane',
      french: 'Sefora',
      swahili: 'Seswahili'
    },
    theme: 'Mookotaba (Theme)',
    themes: {
      light: 'Lesedi',
      dark: 'Lefifi',
      system: 'Sistimi'
    },
    fontSize: 'Boholo ba Fonto',
    notifications: 'Ditemoso',
    emailUpdates: 'Dintlafatso tsa Imeile',
    soundNotifications: 'Ditemoso tsa Modumo',
    accountManagement: 'Tsamaiso ya Akhaonto',
    emailAddress: 'Aterese ya Imeile',
    emailAddressPlaceholder: 'Aterese ya hao ya imeile',
    password: 'Phasewete',
    changePassword: 'Fetola Phasewete',
    resetUserData: 'Seta Datha ya Mosebedisi Botjha',
    resetUserDataDesc: 'Sena se tla hlakola datha yohle ya profaele ya hao le nalane ya moqoqo.',
    deleteAccount: 'Hlakola Akhaonto',
    deleteAccountDesc: 'Sena se tla hlakola akhaonto ya hao ka ho sa feleng le datha yohle e amanang le yona.',
    edit: 'Fetola',
    standardAccount: 'Akhaonto e Tlwaelehileng',
    confirmEmailChange: 'Netefatsa Phetoho ya Imeile',
    pleaseEnterPassword: 'Ka kopo kenya phasewete ya hao',
    cancel: 'Hlakola',
    account: {
      title: 'Akhaonto',
      resetDescription: 'Sena se tla hlakola datha yohle ya profaele ya hao le nalane ya moqoqo.',
      confirmReset: 'Na o na le bonnete ba hore o batla ho seta datha ya hao yohle botjha? Sena ha se kgutlisetswe morao.',
      resetComplete: 'Datha ya hao e setilwe botjha.'
    },
    language: {
      title: 'Puo',
      selectLabel: 'Puo ya Ponahalo'
    },
    appearance: {
      title: 'Ponahalo',
      lightTheme: 'Lesedi',
      darkTheme: 'Lefifi',
      systemTheme: 'Sistimi'
    },
    confirmDeleteAccount: 'Na o na le bonnete ba hore o batla ho hlakola akhaonto ya hao? Keto ena ha e kgutlele morao.',
    confirmAccountDeletion: 'Netefatsa ho Hlakolwa ha Akhaonto',
    accountDeletionWarning: 'Temoso: Keto ena ke ya moshwelella mme ha e kgutlele morao. Datha ya hao yohle e tla hlakolwa ka ho sa feleng.',
    deletionReason: 'Lebaka la ho hlakolwa (kgetho):',
    deletionReasonPlaceholder: 'Ke eng se entseng hore o etse qeto ya ho hlakola akhaonto ya hao?',
    enterPasswordConfirm: 'Kenya phasewete ya hao ho netefatsa:',
    currentPasswordPlaceholder: 'Phasewete ya hao ya hona jwale',
    deleting: 'Ea hlakola...',
    permanentlyDeleteAccount: 'Hlakola Akhaonto',
    accountDeletedSuccess: 'Akhaonto ya hao e hlakotswe ka katleho.',
    incorrectPassword: 'Phasewete e fosahetseng',
    accountDeletionFailed: 'Ho hlolehile ho hlakola akhaonto. Ka kopo leka hape hamorao.',
    confirmChange: 'Netefatsa Phetoho',
    processing: 'E ntse e sebetsa...',
    userDataReset: 'Datha ya profaele ya hao e setilwe botjha ka katleho.',
    failedToResetUserData: 'Ho hlolehile ho seta datha ya profaele ya hao botjha. Ka kopo leka hape hamorao.',
    changingEmailTo: 'Ho fetola imeile ya hao ho',
    will: 'tla',
    logOutSystem: 'Ho o ntsha tsamaisong (Log out)',
    sendVerificationLink: 'Romela link ya netefatso ho imeile ya hao e ntjha',
    requireVerification: 'Hloka netefatso pele o ka kena hape',
    checkNewEmailVerification: 'Ka kopo hlahloba imeile ya hao e ntjha bakeng sa ditaelo tsa netefatso.',
    unableToVerifyEmail: 'E sitwa ho netefatsa imeile. Ka kopo leka hape.',
    emailAlreadyInUse: 'Imeile e se e ntse e sebediswa',
    enterValidEmail: 'Ka kopo kenya aterese ya imeile e nepahetseng',
    failedToUpdateEmail: 'Ho hlolehile ho ntlafatsa imeile. Ka kopo leka hape.',
    passwordResetInitiated: 'Link ya ho seta phasewete e rometswe atereseng ya hao ya imeile.',
    unableToLoadUser: 'E sitwa ho kenya tlhahisoleseding ya mosebedisi. Ka kopo leka hape.',
    retry: 'Leka hape',
    user: 'Mosebedisi',
    loadingUserInfo: 'E kenya tlhahisoleseding ya mosebedisi...',
    resetUserDataTitle: "Seta Datha ya Mosebedisi Botjha",
    confirmResetUserData: "Na o na le bonnete ba hore o batla ho seta datha ya profaele ya hao yohle botjha? Sena se tla hlakola tlhahisoleseding yohle ya profaele ya hao le nalane ya moqoqo, empa se boloka dintlha tsa hao tsa ho kena.",
    reset: "Seta Botjha",
    deleteAccountTitle: "Hlakola Akhaonto"
  },
  userProfile: {
    title: 'Profaele ya Mosebedisi',
    privacyInfo: "Ka ho fana ka tlhahisoleseding e eketsehileng, o tla fumana dikarabo tse nepahetseng le tse nang le moelelo ho tswa ho chatbot. Ka kopo hlahloba tsa rona",
    privacyPolicyLink: 'Leano la Lekunutu',
    tabComingSoon: 'Lethathamo lena le ntse le thehwa mme le tla fumaneha haufinyane.',
    saveSuccess: 'Profaele e bolokilwe ka katleho',
    loadError: 'Phoso ha ho kenngwa datha ya profaele',
    saveError: 'Phoso ha ho bolokwa profaele',
    confirmSaveTitle: "Boloka Profaele",
    confirmSave: "Na o na le bonnete ba hore o batla ho boloka diphetoho tsee?",
    confirmCancel: 'O na le diphetoho tse sa bolokoang. Na o na le bonnete ba hore o batla ho hlakola?',
    confirmLeave: 'Na o na le bonnete ba hore o batla ho tsamaya? Diphetoho dipe kapa dipe tse sa bolokoang di tla lahleha.',
    confirmDiscardChanges: 'Lahla diphetoho tse sa bolokoang?',
    uploadPhoto: 'Kenya Senepe',
    uploadFile: 'Kenya Faele',
    photoRequirements: 'Senepe se tlameha ho hlakahala, se sa tswa nkuwa, le ho bontsha sefahleho sa hao se feletseng',
    biometricRequirements: 'Ke difaele tsa datha tsa biometric tsa semmuso feela tse amohelwang',
    documentUpload: 'Tlhahiso ya Ditokomane',
    validationTitle: 'Ka kopo lokisa diphoso tse latelang:',
    profileIcon: 'Letshwao la Profaele',
    change: 'Fetola',
    chooseProfileIcon: 'Kgetha Letshwao la Profaele',
    presetIcons: 'Matshwao a Setilweng',
    upload: 'Kenya',
    initials: 'Ditlhaku tsa pele (Initials)',
    clickToUpload: 'Tobetsa ho kenya',
    useThisImage: 'Sebedisa Setshwantsho Sena',
    useInitials: 'Sebedisa Ditlhaku tsa Pele',
    tabs: {
      tab1: 'Datha ya Boitsebiso ba Botho',
      tab2: 'Ngwadisong ya Baahi & Litokomane',
      tab3: 'Aterese & Tlhahisoleseding ya Bodulo',
      tab4: 'Boitsebiso & Ditokomane tsa Leeto',
      tab5: 'Bophelo bo Botle & Ditlaleho tsa Meriana',
      tab6: 'Mesebetsi & Datha ya Moruo',
      tab7: 'Thuto & Ditlaleho tsa Sekolo',
      tab8: 'Datha ya Ditjhelete & Lekgetho',
      tab9: 'Tshireletso ya Setjhaba & Boiketlo',
      tab10: 'Ditlaleho tsa Botlokotsebe & tsa Molao',
      tab11: 'Dipalangwang & Tsela',
      tab12: 'Ho Nka Karolo ha Baahi & Dipolotiki'
    },
    actions: {
      cancel: 'Hlakola',
      save: 'Boloka Profaele',
      previous: 'E fetileng',
      next: 'E latelang',
      saving: 'Ea boloka...'
    },
    fields: {
      fullName: 'Lebitso le feletseng (ho kenyeletswa le mabitso a mang)',
      dob: 'Letsatsi la tswalo',
      gender: 'Bong',
      nationality: 'Bochaba',
      maritalStatus: 'Boemo ba Lenyalo',
      photograph: 'Senepe',
      biometric: 'Menwana / Datha ya Biometric',
      birthCert: 'Setifikeiti sa tswalo',
      deathCert: 'Setifikeiti sa lefu',
      marriageDivorce: 'Lenyalo / Ditlaleho tsa thalano',
      adoption: 'Ditlaleho tsa kgodiso e molaong (adoption)',
      citizenship: 'Boahi / Ditokomane tsa boahi',
      immigration: 'Bofalli & nalane ya visa',
      currentAddress: 'Aterese ya hona jwale ya bolulo',
      previousAddresses: 'Diaterese tse fetileng',
      postalCode: 'Khoutu ya poso',
      country: 'Naha',
      residencyStatus: 'Boemo ba Bodulo',
      homeOrRental: 'Dintlha tsa thepa ya ntlo kapa e hirilweng',
      utilityBills: 'Dibili tse amanang le aterese (motlakase kapa metsi)',
      landRecords: 'Mobu le ditlaleho tsa ho ba mong a thepa',
      idCard: 'Nomoro ya karata ya naha ya ID',
      passport: 'Dintlha tsa pasporoto',
      driversLicense: "Laesense ya ho kganna",
      voterId: 'ID ya mokgethi',
      ssn: 'Tshireletso ya Setjhaba / Nomoro ya Inshorense ya Naha',
      militaryRecords: 'Ditlaleho tsa tshebeletso ya sesole',
      medicalHistory: 'Nalane ya tsa bongaka le maemo a bophelo bo botle',
      vaccinations: 'Ditlaleho tsa ho entwa',
      insuranceDetails: 'Dintlha tsa inshorense ya bophelo bo botle',
      disability: 'Boemo ba ho holofala',
      bloodType: 'Mofuta wa Madi',
      organDonor: 'Boemo ba ho fana ka setho (organ donor)',
      prescriptions: 'Meriana e ngotsweng le dikalafi tse fumanweng',
      mentalHealth: 'Nalane ya bophelo ba kelello',
      eHistory: 'Nalane ya mosebetsi',
      currentEmployer: 'Dintlha tsa mothapi wa hona jwale',
      workPermits: 'Diphemiti tsa ho sebetsa le dikonteraka tsa basebetsi',
      certifications: 'Difiketi le dilaesense tsa botsebi',
      unemployment: 'Boemo ba ho hloka mosebetsi le melemo e fumanweng',
      tin: 'Nomoro ya boitsebiso ba molefa-lekgetho (TIN)',
      businessAffiliations: 'Boitsebiso ba kgwebo le maqhama a kgotla',
      schools: 'Dikolo le diyunivesithi tseo o di kentseng',
      education: 'Thuto',
      degrees: 'Didiploma, didigrii, le ditifikeiti',
      performance: 'Tshebetso ya thuto le matshwao a teko',
      academicRecords: "Ditlaleho tsa Sekolo",
      scholarships: 'Dithuso tsa dithuto le thuso ya ditjhelete e fumanweng',
      incomeTax: 'Ditlaleho tsa lekgetho la lekeno',
      bankAccounts: 'Diakhaonto tsa banka le tsa ditjhelete',
      propertyTax: 'Ditefello tsa lekgetho la thepa',
      businessTax: 'Difaele tsa lekgetho la kgwebo',
      pensionContrib: 'Ditefello tsa penshene le ditlhahiso',
      loanAid: 'Ditefiso le ditlaleho tsa thuso ya mmuso',
      pensionStatus: 'Boemo ba penshene le tlatsetso',
      childcare: 'Thuso ya tlhokomelo ya bana',
      foodAssistance: 'Thuso ya dijo / mananeo a boiketlo',
      housingAssistance: 'Thuso ya matlo',
      policeRecords: 'Ditlaleho tsa sepolesa (nalane ya botlokotsebe, tshwaro, liqoso)',
      courtCases: 'Nalane ya nyeoe ya kgotla',
      finesPenalties: 'Ditefiso le dikotlo',
      paroleProbation: 'Boemo ba tshepiso e molaong kapa boikemisetso',
      citizenshipRevocation: 'Ho amohwa baahi (haeba ho hlokahala)',
      vehicleReg: 'Dintlha tsa ngwadisong ya koloi',
      trafficViolations: 'Ditlolo tsa molao wa sephethephethe le ditefiso',
      licenseHistory: 'Nalane ya laesense ya ho kganna le ditumellano',
      publicTransportCard: 'Tshebediso ya karata ya dipalangwang tsa setjhaba',
      voterRegistration: 'Dintlha tsa ngwadisong ya mokgethi',
      electionHistory: 'Nalane ya ho nka karolo dikgethong',
      partyMembership: 'Botho ba mokga wa sepolotiki',
      militaryStatus: 'Tshebeletso ya sesole kapa boemo ba conscription',
      publicServiceRoles: 'Dikarolo tsa tshebeletso ya setjhaba'
    },
    placeholders: {
      fullName: 'Kenya lebitso la hao le feletseng la molao',
      nationality: 'Kenya bochaba ba hao',
      searchCountries: 'Batla dinaha...',
      selectCountry: 'Kgetha naha',
      searchDisciplines: "Batla dithuto...",
      selectDiscipline: "Kgetha thuto",
      searchDegrees: "Batla didigrii...",
      selectDegree: "Kgetha digrii"
    },
    validation: {
      nameRequired: 'Lebitso le feletseng lea hlokahala',
      dobRequired: 'Letsatsi la tswalo lea hlokahala',
      dobFuture: 'Letsatsi la tswalo le ke ke la ba kamoso',
      requiredField: '{field} ea hlokahala',
      invalidFormat: 'Sebopeho se fosahetseng bakeng sa {field}',
      futureDate: 'Letsatsi le ke ke la ba kamoso',
      invalidSelection: 'Ka kopo, etsa kgetho e nepahetseng',
      passwordLength: 'Phasewete e tlameha ho ba le ditlhaku tse 8 bonyane',
      matchError: 'Dikarolo ha di tshwane'
    },
    errors: {
      savingFailed: 'Ho hlolehile ho boloka profaele',
      loadingFailed: 'Ho hlolehile ho kenya datha ya profaele',
      invalidForm: 'Ka kopo tlatsa dikarolo tsohle tse hlokahalang',
      invalidFileType: 'Mofuta wa faele o fosahetseng',
      fileTooLarge: 'Faele e kgolo haholo',
      countryLoadError: 'Phoso ha ho kenngwa dinaha',
      countryUpdateError: 'Phoso ha ho ntlafatswa naha'
    },
    notifications: {
      saveSuccess: 'Profaele e bolokilwe ka katleho',
      saveFailed: 'Ho hlolehile ho boloka profaele',
      loadSuccess: 'Profaele e kentswe ka katleho',
      loadFailed: 'Ho hlolehile ho kenya profaele',
      fieldRequired: 'Lekala lena lea hlokahala',
      uploadSuccess: 'Faele e kentswe ka katleho',
      uploadFailed: 'Ho hlolehile ho kenya faele',
      formChanged: 'O na le diphetoho tse sa bolokoang',
      sessionExpired: 'Nako ya hao e fedile, ka kopo kena hape',
      profileUpdated: 'Profaele ya hao e ntlafaditswe',
      profileIncomplete: 'Profaele ya hao ha ea fella'
    },
    instructions: {
      fullNameHelp: 'Kenya lebitso la hao le feletseng e leng leo le hlahang ditokomaneng tsa hao tsa semmuso',
      dobHelp: 'Kenya letsatsi la hao la tswalo ka sebopeho sa MM/DD/YYYY',
      uploadPhotoHelp: 'Kenya senepe se sa tswa nkuwa. Faele e tlameha ho ba JPG, PNG, kapa GIF mme e be ka tlase ho 2MB',
      passwordHelp: 'Phasewete e tlameha ho ba bonyane ditlhaku tse 8 e nang le tlhaku e le nngwe e kgolo, nomoro e le nngwe, le tlhaku e le nngwe e kgethehileng',
      documentHelp: 'Mefuta e amohelehang: PDF, JPG, PNG (max 5MB)',
      requiredFields: 'Dikarolo tse tshwailweng ka * dia hlokahala',
      selectFromList: 'Ka kopo kgetha kgetho ho tswa lenaneng',
      nextTab: 'Tswela pele karolong e latelang',
      previousTab: 'Khutlela karolong e fetileng',
      saveInstructions: 'Tobetsa Boloka ho theha tlhahisoleseding ya hao',
      cancelInstructions: 'Tobetsa Hlakola ho lahla diphetoho'
    },
    completionStatus: {
      notStarted: 'Ha e ya Qalwa',
      inProgress: 'E ntse E Tswela Pele',
      complete: 'E Phethetswe',
      percentComplete: '{percent}% e phethetswe',
      tabsCompleted: '{completed} ho {total} tsa dikarolo di phethetswe',
      tabComplete: 'Karolo e phethetswe!'
    },
    gender: {
      male: 'Monna',
      female: 'Mosadi',
      other: 'E Nngwe',
      preferNot: 'Nka thabela ho se bue'
    },
    maritalStatus: {
      single: 'O lesoha / O le nnotshi',
      married: 'O nyetswe/nyetse',
      divorced: 'O hlalane',
      widowed: 'Mohlolohadi / Mohlohlolo',
      other: 'E Nngwe'
    },
    residencyStatuses: {
      citizen: 'Moahi',
      permanentResident: 'Moahi wa Moshwelella',
      temporaryResident: 'Moahi wa Nakwana',
      other: 'E Nngwe'
    },
    employmentStatuses: {
      employed: 'Ya Sebetsang',
      selfEmployed: 'Ya Ithusang ka Kgwebo',
      unemployed: 'Ya sa Sebetseng',
      student: 'Moithuti',
      retired: 'Motho Ya Hodileng / Pension',
      homemaker: 'Motho wa ka tlung',
      other: 'E Nngwe'
    },
    educationLevels: {
      primary: 'Thuto ya Motheo (Primary)',
      secondary: 'Thuto ya Sekondari',
      highSchool: 'Sekolo se Phahameng',
      vocational: 'Koetliso ya Mosebetsi',
      associate: 'Digrii ya Associate',
      bachelor: 'Digrii ya Bachelor',
      master: 'Digrii ya Master',
      doctoral: 'Digrii ya Doctoral',
      professional: 'Digrii ya Professional',
      other: 'E Nngwe'
    },
    proficiencyLevels: {
      native: 'Puo ya letsobele',
      fluent: 'E Thellang / Fluent',
      advanced: 'E Tswetseng pele',
      intermediate: 'E Mahareng',
      basic: 'E Bonolo'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Ha e tsejwe'
    },
    languages: {
      english: 'Senyesemane',
      french: 'Sefora',
      swahili: 'Seswahili',
      arabic: 'Siarabia',
      spanish: 'Sepanishe',
      portuguese: 'Sepotoketsi',
      chinese: 'Setjhaena',
      japanese: 'Sejapane',
      german: 'Sejeremane',
      russian: 'Serussia',
      hindi: 'Sehindi',
      urdu: 'Se-Urdu',
      other: 'E Nngwe'
    },
    yesNo: {
      yes: 'E',
      no: 'Che'
    },
    select: 'Ka kopo kgetha',
    existingFile: 'Faele e teng',
    noMatchingCountries: 'Ha ho dinaha tse fumanweng',
    noMatchingDisciplines: "Ha ho dithuto tse fumanweng",
    noMatchingDegrees: "Ha ho didigrii tse fumanweng",
    educationOptions: [
      "Accounting", "Aerospace Engineering", "Agricultural Science", "Anthropology", "Architecture",
      "Art History", "Artificial Intelligence", "Astronomy", "Astrophysics", "Biochemistry",
      "Biomedical Engineering", "Biotechnology", "Business Administration", "Chemical Engineering",
      "Chemistry", "Civil Engineering", "Communications", "Computer Engineering", "Computer Science",
      "Construction Management", "Criminal Justice", "Cybersecurity", "Data Science", "Dentistry",
      "Economics", "Education", "Electrical Engineering", "Elementary Education", "English Literature",
      "Environmental Engineering", "Environmental Science", "Fashion Design", "Film Studies",
      "Finance", "Fine Arts", "Food Science", "Forensic Science", "Game Design", "Geography",
      "Geology", "Graphic Design", "Health Administration", "History", "Hospitality Management",
      "Human Resources", "Industrial Design", "Industrial Engineering", "Information Systems",
      "Information Technology", "Interior Design", "International Business", "International Relations",
      "Journalism", "Law", "Library Science", "Linguistics", "Management", "Marketing",
      "Materials Science", "Mathematics", "Mechanical Engineering", "Media Studies", "Medicine",
      "Meteorology", "Microbiology", "Music", "Nanotechnology", "Nursing", "Nutrition",
      "Occupational Therapy", "Oceanography", "Petroleum Engineering", "Pharmacy", "Philosophy",
      "Photography", "Physical Education", "Physical Therapy", "Physics", "Political Science",
      "Psychology", "Public Administration", "Public Health", "Public Relations", "Robotics",
      "Secondary Education", "Social Work", "Sociology", "Software Engineering", "Special Education",
      "Sports Management", "Statistics", "Systems Engineering", "Theatre Arts", "Tourism",
      "Urban Planning", "Veterinary Medicine", "Web Development", "Wildlife Biology", "Zoology"
    ],
    degreeOptions: [
      "Associate Degree", "Bachelor of Arts (BA)", "Bachelor of Science (BS)", "Bachelor of Engineering (BEng)",
      "Bachelor of Business Administration (BBA)", "Bachelor of Fine Arts (BFA)", "Bachelor of Education (BEd)",
      "Bachelor of Medicine (MBBS)", "Bachelor of Laws (LLB)", "Master of Arts (MA)", "Master of Science (MS)",
      "Master of Business Administration (MBA)", "Master of Engineering (MEng)", "Master of Fine Arts (MFA)",
      "Master of Education (MEd)", "Master of Laws (LLM)", "Master of Public Health (MPH)",
      "Doctor of Philosophy (PhD)", "Doctor of Medicine (MD)", "Doctor of Education (EdD)",
      "Doctor of Business Administration (DBA)", "Doctor of Jurisprudence (JD)", "Professional Diploma",
      "Technical Diploma", "Vocational Certificate", "Graduate Certificate", "Post-Graduate Diploma", "Post-Doctoral"
    ],
    aria: {
      tabList: 'Dikarolo tsa foromo ya profaele',
      nextButton: 'Eya karolong e latelang',
      prevButton: 'Eya karolong e fetileng',
      closeButton: 'Kwala foromo ya profaele',
      saveButton: 'Boloka datha ya profaele',
      requiredField: 'Lekala le hlokahalang',
      dropdownSelect: 'Kgetha e nngwe'
    }
  },
  chatbot: {
    placeholder: 'Ngola potso ya hao mona...',
    sendButton: 'Romela',
    fileReceived: 'Faele e amohetswe ka katleho.',
    fileUploadError: 'Phoso ha ho kenngwa faele.',
    processingError: 'Phoso ha ho thehwa kopo ya hao.',
    welcomeMessage: 'Kena ka kgotso! Nka o thusa jwang ka ditshebeletso tsa mmuso wa Kenya kajeno?',
    attachFile: 'Lema Faele (Attach)',
    fileTooLarge: 'Faele e kgolo haholo. Boholo bo kgethehileng ke {maxSize}.',
    saveChat: 'Boloka Moqoqo',
    chatSaved: 'Moqoqo o Bolokilwe',
    chatTitle: 'Sehlooho sa Moqoqo',
    chatTitlePlaceholder: 'Kenya sehlooho bakeng sa moqoqo ona',
    selectFolder: 'Kgetha Sephuthedi',
    newChat: 'Moqoqo o Motjha',
    clearContext: 'Hlakola nalane mme o qale moqoqo o motjha',
    unsavedChanges: 'O na le diphetoho tse sa bolokoang. Na o na le bonnete ba hore o batla ho qala moqoqo o motjha?',
    whatCanIHelp: "Nka o thusa jwang kajeno?",
    justChat: "Moqoqo Feela",
    queryContext: "Mongolo wa Potso",
    contextAdded: 'Tlhaloso e ekeditswe potsong ya hao',
    contextRemoved: 'Tlhaloso e tlositswe potsong ya hao',
    sessionUpdated: 'Seshene e ntlafaditswe',
    newChatStarted: 'O qadile moqoqo o motjha',
    loadError: 'E sitwa ho kenya nalane ya moqoqo',
    responsePrefix: "Ke amohetse molaetsa wa hao",
    withContext: "e nang le tlhaloso",
    conversationLoaded: "Moqoqo o kentswe ka katleho!",
    saveConfirmTitle: "Boloka Moqoqo o Leng Teng",
    saveConfirmMessage: "Boloka moqoqo o leng teng?",
    loadConfirmTitle: "Kenya Moqoqo o Leng Teng",
    loadConfirmMessage: "O na le diphetoho tse sa bolokoang. Na o batla ho di lahla le ho kenya moqoqo o kgethilweng, kapa boloka moqoqo wa hona jwale pele?",
    loadAndDiscard: "Kenya mme o Lahle",
    saveAndLoad: "Boloka mme o Kenye",
    saveAndStartNew: "Boloka mme o Qale e Ntjha",
    discardAndStartNew: "Lahla mme o Qale e Ntjha",
    newChatTitle: "Qala Moqoqo o Motjha",
    exportChat: 'Ntshetsa Moqoqo Kantle',
    exportFilename: 'Lebitso la Faele',
    exportFilenamePlaceholder: 'Kenya lebitso la faele',
    exportButton: 'Ntshetsa Kantle',
    exportSuccess: 'Moqoqo o ntsheditswe kantle ka katleho',
    exportError: 'Ho hlolehile ho ntshetsa moqoqo kantle. Ka kopo leka hape.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Kopa ID",
    payTaxes: "Lefa lekgetho",
    startBusiness: "Qala kgwebo",
    findHealthcare: "Bophelo",
    educationServices: "Thuto",
    transportLicenses: "Dipalangwang",
    housingPrograms: "Matlo",
    findJobs: "Mosebetsi",
    justChat: "Moqoqo Feela",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "Ke rata ho qoqa ka ditshebeletso tsa mmuso",
    applyForIDUserPrompt: "Ke hloka tlhahisoleseding mabapi le hore na nka etsa kopo ya karata ya naha ya ID jwang",
    payTaxesUserPrompt: "Ke tshebetso efe bakeng sa ho lefa lekgetho la ka inthaneteng?",
    startBusinessUserPrompt: "Ntsamaise mehatong ya ho ngodisa kgwebo e ntjha",
    findHealthcareUserPrompt: "Nka fumana hokae tlhahisoleseding ka ditshebeletso tsa setjhaba tsa bophelo bo botle?",
    educationServicesUserPrompt: "Ke ditshebeletso dife tsa thuto tse fumanehang bakeng sa bana ba ka?",
    transportLicensesUserPrompt: "Nka ntjhafatsa laesense ya ka ya ho kganna jwang?",
    housingProgramsUserPrompt: "Bolelle ka mananeo a matlo a theko e tlase a Kenya",
    findJobsUserPrompt: "Ke menyetla efe ya mosebetsi ya mmuso e fumanehang ha jwale?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Hlakola',
    create: 'Theha',
    save: 'Boloka',
    move: 'Tlosa',
    delete: 'Hlakola',
    ok: 'Ho lokile',
    ingest: 'Kenya',
    retract: 'Hulela Morao',
    loading: 'Ea kenya...',
    refresh: 'Ntjhafatsa'
  },
  feedback: {
    title: 'Maikutlo',
    button: 'Maikutlo',
    positive: 'Maikutlo a matle',
    negative: 'Maikutlo a mabe',
    promptText: 'Na karabo ena e bile le thuso?',
    placeholder: 'Maikutlo a mang...',
    submit: 'Romela Maikutlo',
    close: 'Hlakola',
    thankYouMessage: 'Ke leboha maikutlo a hao!',
    submitting: 'Ea romela...',
    error: 'Ho na le se fosahetseng. Ka kopo leka hape.',
    success: 'Ke leboha maikutlo a hao!',
  },
  responseRating: {
    title: 'Re Thuse ho Ntlafatsa',
    note: 'Maikutlo a hao a tla sebediswa ho beha chatbot betere mme ho ntlafatsa dikarabo ha nako e ntse e tsamaya.',
    chatbotResponse: 'Karabelo ya Chatbot:',
    ratingLabels: {
      1: 'E se Nang Thuso',
      2: 'E Thusang Hanyane',
      3: 'E Thusang ho se Hakaalo',
      4: 'E Thusang Haholo',
      5: 'E Fetolang Bophelo'
    },
    additionalComments: 'Maikutlo a mang...',
    submit: 'Romela',
    cancel: 'Hlakola'
  },
  upload: {
    alt: 'Kenya'
  },
  details: {
    loading: 'E kenya Dintlha tsa Faele...',
    title: 'Dintlha tsa Faele',
    close: 'Kwala',
    fileName: 'Lebitso la Faele',
    author: 'Mongodi',
    labels: 'Mabitso',
    selectAll: 'Kgetha Tsohle',
    loadingLabels: 'E kenya mabitso...',
    status: 'Boemo',
    fileId: 'ID ya Faele',
    fileType: 'Mofuta wa Faele',
    viewFile: 'Bona Faele',
    visitLink: 'Eya Link ea Kantle',
    openFile: 'Bula faele ho thepo e ntjha',
    fileSize: 'Boholo ba Faele',
    uploadDate: 'Letsatsi la ho Kenya',
    hash: 'SHA256 Hash',
    tabs: {
      details: "Dintlha",
      ingestionLog: "Log ya ho Kenya"
    },
    log: {
      killActions: "Diketo tsa ho Bolaya:",
      killDocument: "Bolaya Tokomane Ena",
      killProcess: "Bolaya Tshebetso ya ho Kenya",
      timestamp: "Setempe sa Nako (Timestamp)",
      level: "Boemo",
      stage: "Setha",
      message: "Molaetsa",
      loadingLogs: "E kenya lilog...",
      noLogs: "Ha ho na lilog tse fumanweng."
    },
    buttons: {
      saveMetadata: 'Boloka Metadata',
      retract: 'Hulela Morao',
      ingest: 'Kenya'
    },
    notifications: {
      loadError: 'Ho hlolehile ho kenya dintlha tsa faele.',
      validationError: 'Lebitso la Faele le Mongodi di a hlokahala.',
      saveSuccess: 'Metadata e ntlafaditswe ka katleho.',
      saveError: 'Ho hlolehile ho boloka metadata.',
      tokenError: 'Letshwao la netefatso ha le fumanwe dathang ya mosebedisi.',
      viewError: 'Ha e kgone ho kenya faele hore o e bone.',
      ingestSuccess: 'Faele e kentsoe moleng wa ho kentshwa ka katleho.',
      ingestError: 'Ho hlolehile ho qala tshebetso ya ho kenya.',
      retractSuccess: 'Faele e huletswe morao.',
      retractError: 'Ho hlolehile ho hulela faele morao.',
      deleteSuccess: 'Faele e hlakotswe ka katleho.',
      deleteError: 'Ho hlolehile ho hlakola faele.',
      ingestLabelRequired: "Ka kopo kgetha lebapa le le leng bonyane pele ho kentshwa.",
      ingestSaving: "E boloka metadata pele e kengwa...",
      ingestSaveFailed: "Ho hlolehile ho boloka metadata. Kentsho e hlakotswe.",
      logError: "Ho hlolehile ho latedisa lilog tsa ho kenya.",
      killDocSent: "Kopo ya ho bolaya bakeng sa tokomane ena e rometswe.",
      killProcSent: "Kopo ya ho bolaya bakeng sa tshebetso ya ho kenya e rometswe."
    },
    confirm: {
      ingest: 'Na o na le bonnete ba hore o batla ho kenya faele ena? Sena se tla qala mokgwa wa ho thehwa ha datha.',
      retract: 'Na o na le bonnete ba hore o batla ho hulela faele ena morao?',
      delete: 'Na o na le bonnete ba hore o batla ho hlakola faele ena ka ho sa feleng? Keto ena ha e kgutlele morao.',
      ingestTitle: "Netefatsa ho Kenya",
      retractTitle: "Netefatsa ho Hulela Morao",
      deleteTitle: "Netefatsa ho Hlakola",
      killDocTitle: "Bolaya Kentsho ya Tokomane",
      killDoc: "Na o na le bonnete ba hore o batla ho bolaya mokgwa wa kentsho wa tokomane ENA? Mokgwa ona o tla leka ho itokisa hantle.",
      killProcTitle: "Bolaya Tshebetso YOHLE ya ho Kenya",
      killProc: "TEMOSO: Sena se tla bolaya tshebeletso yohle ya backend e kenyang, e amang difaele KAOFELA tse ntseng di thehwa ha jwale. Na o na le bonnete bo feletseng?"
    }
  },
  uploadDialog: {
    title: 'Kenya Difaele',
    dropzone: 'Hula o behe difaele mona, kapa tobetsa ho kgetha',
    allowedTypesLabel: 'Mefuta e dumelletsweng:',
    buttonUpload: 'Kenya (Mefuta e {count}) ya Faele',
    remove: 'Tlosa',
    uploading: 'Ea kenya...',
    notifications: {
      dropError: 'E batla difaele feela hore di behwe mona. Ka kopo hlahloba hore o hula faele e nepahetseng ho tswa k\'homphieutheng ea hao.',
      typeNotAllowed: 'Mofuta wa faele wa "{extension}" ha o dumellwe.',
      shortcutUnsupported: 'Difaele tsa kgaoletso (.url) ha di tshehetswe. Ka kopo hula faele ya sebele.',
      duplicate: 'Faele ya "{fileName}" e se e ntse e ekeditswe.',
      uploadSuccess: 'E kentswe ka katleho {fileName}',
      uploadFailed: 'Ho hlolehile ho kenya {fileName}.'
    }
  }
}